import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle", "actionMetadata"];
import PropTypes from 'prop-types';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import ClassicEnrollInWorkflowActionSummary from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionSummary';
import ClassicEnrollInWorkflowActionMetadata from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
function ClassicEnrollInWorkflowActionCard(_ref) {
  let {
      actionId,
      getHeaderTitle,
      actionMetadata
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: /*#__PURE__*/_jsx(ClassicEnrollInWorkflowActionSummary, {
      metadata: actionMetadata
    })
  }));
}
ClassicEnrollInWorkflowActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(ClassicEnrollInWorkflowActionMetadata).isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ClassicEnrollInWorkflowActionCard;